import React, { Fragment } from 'react'
import './index.less'
import { goIndex } from '@/assets/js/utils'
class TitlePlus extends React.Component {
    render () {
        const { buriedPointEvent, data: { id, position, trackId, style = {}, sublist = [] } } = this.props
        const {
            backgroundColor,
            textColor,
            backgroundPicUrl,
            jumpBackgroundPicUrl,
            paddingTop
        } = style || {}
        return (
            <Fragment>
                {
                    sublist.map((item, index) => {
                        return (
                            <div
                                className={'TitlePlusContainer statistics-dom'}
                                key={item.id}
                                onClick={() => {
                                    buriedPointEvent({
                                        button_name: `${trackId}`,
                                        button_id: `${id}`,
                                        button_order: `${index + 1}`,
                                        area_order: position,
                                        button_area: `${position}-${trackId}`
                                    })
                                    goIndex(item.url, trackId, item.keyword)
                                }}
                                style={{
                                    backgroundColor,
                                    color: textColor,
                                    backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : '',
                                    marginTop: `${paddingTop ? paddingTop / 75 : 0}rem`
                                }}
                            >
                                <div className={'TitlePlusLeft'}>
                                    {item.title || item.subtitle || '默认标题'}
                                </div>
                                <div className={'TitlePlusRight'}>
                                    {jumpBackgroundPicUrl ? (<img src={jumpBackgroundPicUrl} alt='' />) : null}
                                </div>
                            </div>
                        )
                    })
                }
            </Fragment>

        )
    }
}

export default TitlePlus
